import React, { useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// MUI
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CardActions,
  Button,
  CircularProgress,
  TextField,
  useTheme,
} from '@mui/material';

// Icons
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentsIcon from '@mui/icons-material/Payments';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import LocationCityIcon from '@mui/icons-material/LocationCity';

// Actions
import {
  Delete_Selected_Commission_Schedual_Data_Action,
  Get_All_Commission_Schedual_Data_Action,
} from '../Redux/Actions/Commission_Schedual_Dates_Actions';
import { Add_Commission_Pay_Data_Action } from '../Redux/Actions/Commission_pay_Action';

// Components
import { Notify } from '../Utility/Notify';
import { PaymentsTable } from './PaymentsTable';

export const CommissionSchedualDatesPreviewpage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع ال

  const { id } = useParams();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const [showPayModal, setShowPayModal] = useState(false);
  const [selectedPayId, setSelectedPayId] = useState(null);
  const [money, setMoney] = useState('');
  const [loadingPay, setLoadingPay] = useState(false);

  const handleDelete = async () => {
    if (!selectedDeleteId) return;
    await dispatch(Delete_Selected_Commission_Schedual_Data_Action(selectedDeleteId));
    Notify('success', 'Document Deleted Successfully', 'success');
    setShowDeleteModal(false);
    setSelectedDeleteId(null);
    getData();
  };

  const handlePay = async () => {
    if (!selectedPayId) return;
    setLoadingPay(true);

    const item = AllData_Array.find((i) => i._id === selectedPayId);
    if (!item) return;

    const payload = {
      Lead: item?.lead?._id || item?.commission?.lead?._id,
      project: item?.commission?.project?._id,
      DateOfPayment: item?.Date,
      MoneyOfPayment: item?.MoneyPayment,
      moneyispaid: money,
      Commission: item?.commission?._id,
    };

    await dispatch(Add_Commission_Pay_Data_Action(payload));
    setShowPayModal(false);
    setLoadingPay(false);
    setMoney('');
    Notify('success', 'Payment Added Successfully', 'success');
    getData();
    window.location.reload(false);
  };

  const getData = async () => {
    setLoading(true);
    await dispatch(Get_All_Commission_Schedual_Data_Action(id));
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [dispatch, id]);

  const resALLdataSchdualdate = useSelector(
    (state) => state.AllSchedual_Commission_Dates.Add_Payment_Date,
  );
  const AllData_Array = Array.isArray(resALLdataSchdualdate?.data)
    ? resALLdataSchdualdate.data
    : [];

  return (
    <Container className="startpage py-4 fade-in">
      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          Are you sure you want to delete this document?
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Confirm Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Payment Modal */}
      <Modal show={showPayModal} onHide={() => setShowPayModal(false)}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Confirm Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <TextField
            value={money}
            onChange={(e) => setMoney(e.target.value)}
            label="Money Paid"
            type="number"
            variant="outlined"
            className="w-100 my-2"
          />
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={() => setShowPayModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handlePay}>
            Confirm Pay
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Breadcrumb */}
      <Box mb={3}>
        <Link
          to="/LeadsForAccountant"
          style={{ textDecoration: 'none', color: '#0F7687', fontWeight: 'bold' }}
        >
          Home
        </Link>
        <KeyboardDoubleArrowRightIcon />
        <span style={{ fontWeight: 'bold', color: '#333' }}>Commission Payment Schedule</span>
      </Box>

      <hr />
      <Box mt={6}></Box>

      {loading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          mt={6}
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <CircularProgress color="primary" />
          <Typography variant="body2" mt={2}>
            Loading payment data...
          </Typography>
        </Box>
      ) : (
        // style={{color: mode === "dark" ? "#90caf9" : "#0F7687",backgroundColor: mode === "dark" ? "#252525" : "#f5f5f5"}}
        <Grid container spacing={3}>
          {AllData_Array.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={item._id || index}>
              <Card
                sx={{
                  color: mode === 'dark' ? '#90caf9' : '#0F7687',
                  backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  borderRadius: 2,
                  boxShadow: 3,
                  p: 2,
                  transition: '0.3s',
                  '&:hover': { boxShadow: 6 },
                }}
              >
                <CardContent>
                  <Box mb={1}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                    >
                      <PersonIcon sx={{ fontSize: 18 }} /> Lead Name
                    </Typography>
                    <Typography variant="subtitle1">{item.lead?.name || 'Unnamed Lead'}</Typography>
                  </Box>

                  <Box mb={1}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                    >
                      <BusinessIcon sx={{ fontSize: 18 }} /> Developer
                    </Typography>
                    <Typography variant="subtitle1">
                      {item.lead?.project?.developer?.name || 'N/A'}
                    </Typography>
                  </Box>

                  <Box mb={1}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                    >
                      <LocationCityIcon sx={{ fontSize: 18 }} /> Project
                    </Typography>
                    <Typography variant="subtitle1">{item.lead?.project?.name || 'N/A'}</Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: '#0F7687', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}
                  >
                    <CalendarMonthIcon sx={{ color: '#0F7687' }} /> First Payment Date:
                    {item.commission?.paymentDate
                      ? new Date(item.commission.paymentDate).toLocaleDateString('en-GB')
                      : 'N/A'}
                  </Typography>

                  <Box mb={1}>
                    <Typography variant="body2" color="text.secondary">
                      💰 Commission Value
                    </Typography>
                    <Typography variant="subtitle1">
                      {item.commission?.commissionValue?.toLocaleString()} AED
                    </Typography>
                  </Box>

                  <Box mb={1}>
                    <Typography variant="body2" color="text.secondary">
                      📅 Payment Date
                    </Typography>
                    <Typography variant="subtitle1">
                      {new Date(item.Date).toLocaleDateString()}
                    </Typography>
                  </Box>

                  <Box mb={1}>
                    <Typography variant="body2" color="text.secondary">
                      💵 Payment Amount
                    </Typography>
                    <Typography variant="subtitle1">
                      {item.MoneyPayment?.toLocaleString()} AED
                    </Typography>
                  </Box>

                  {item.Comment && (
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        📝 Comment
                      </Typography>
                      <Typography variant="subtitle2">{item.Comment}</Typography>
                    </Box>
                  )}
                </CardContent>

                <CardActions sx={{ justifyContent: 'space-between', px: 2 }}>
                  <Link to={`/UpdateSchedualDateForCommission/${item._id}`}>
                    <Button variant="outlined" color="primary" startIcon={<EditIcon />}>
                      Update
                    </Button>
                  </Link>
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                      setSelectedDeleteId(item._id);
                      setShowDeleteModal(true);
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    startIcon={<PaymentsIcon />}
                    onClick={() => {
                      setSelectedPayId(item._id);
                      setShowPayModal(true);
                    }}
                  >
                    Pay
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      <Box mt={10} />
      <hr />
      <PaymentsTable />
    </Container>
  );
};
